<template>
    <div
        v-if="open"
        class="fixed inset-0 z-[1000] flex items-center justify-center p-4"
        role="dialog"
        aria-modal="true"
    >
        <div class="absolute inset-0 bg-black/30" @click="dismiss"></div>
        <div
            class="relative bg-bg-snow rounded-2xl shadow-xl w-full max-w-[640px] overflow-hidden"
        >
            <button
                type="button"
                class="absolute top-4 right-4 z-10 text-fg-tertiary hover:text-fg-secondary"
                @click="dismiss"
            >
                <Icon icon="close" class="w-5 h-5" />
            </button>

            <!-- Preview illustration -->
            <SpendingPreview pad-class="px-6 pt-10 pb-8 min-h-[300px]" />

            <!-- Copy + CTA -->
            <div class="px-6 py-7 sm:px-8">
                <h2 class="text-2xl font-bold text-fg-primary">
                    Introducing <span class="text-10x-orange">My spending</span>
                </h2>
                <p class="mt-1 text-sm text-fg-tertiary">
                    Track spending and rewards across all your cards.
                </p>
                <ul class="mt-5 space-y-3">
                    <li
                        v-for="benefit in benefits"
                        :key="benefit.title"
                        class="flex items-center gap-3"
                    >
                        <span
                            class="flex-shrink-0 w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center"
                        >
                            <Icon
                                :icon="benefit.icon"
                                class="w-4 h-4 text-10x-orange"
                            />
                        </span>
                        <span class="text-sm font-semibold text-fg-primary">
                            {{ benefit.title }}
                        </span>
                    </li>
                </ul>
                <div class="mt-7 flex justify-end">
                    <button
                        type="button"
                        class="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-orange-500 rounded-lg hover:bg-orange-600 transition-colors"
                        @click="explore"
                    >
                        Explore My spending
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { usePage, router } from '@inertiajs/vue3';
import Icon from '@/components/ui/icon/icon.vue';
import SpendingPreview from '@/components/spending/SpendingPreview.vue';

const page = usePage();

// Eligible existing users who haven't opted in or dismissed the promo.
// Suppressed on /spending itself, where the opt-in landing already makes
// the same pitch — stacking the modal on top of it is redundant.
const dismissed = ref(false);
const open = computed(
    () =>
        !dismissed.value &&
        !!page.props.userData?.spending_show_promo &&
        !page.url.startsWith('/spending')
);

const benefits = [
    { icon: 'document', title: 'See all your transactions in one place' },
    { icon: 'coin', title: 'Track rewards on every purchase' },
    { icon: 'graph', title: 'Get tips how to pay smarter & earn more' },
];

const dismiss = () => {
    dismissed.value = true;
    router.post('/spending/promo-dismissed', {}, { preserveScroll: true, preserveState: true });
};

const explore = () => {
    dismissed.value = true;
    router.post(
        '/spending/promo-dismissed',
        {},
        {
            preserveScroll: true,
            onFinish: () => router.visit('/spending'),
        }
    );
};
</script>
